import React, { SVGProps } from 'react';

const SelectedAvatarIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 65 64"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32.5 59.7333C39.8553 59.7333 46.9094 56.8114 52.1104 51.6104C57.3114 46.4094 60.2333 39.3553 60.2333 32C60.2333 24.6447 57.3114 17.5906 52.1104 12.3896C46.9094 7.18856 39.8553 4.26667 32.5 4.26667C25.1447 4.26667 18.0906 7.18856 12.8896 12.3896C7.68856 17.5906 4.76667 24.6447 4.76667 32C4.76667 39.3553 7.68856 46.4094 12.8896 51.6104C18.0906 56.8114 25.1447 59.7333 32.5 59.7333ZM55.1274 54.6274C49.1263 60.6286 40.9869 64 32.5 64C24.0131 64 15.8737 60.6286 9.87258 54.6274C3.87142 48.6263 0.5 40.4869 0.5 32C0.5 23.5131 3.87142 15.3737 9.87258 9.37258C15.8737 3.37142 24.0131 0 32.5 0C40.9869 0 49.1263 3.37142 55.1274 9.37258C61.1286 15.3737 64.5 23.5131 64.5 32C64.5 40.4869 61.1286 48.6263 55.1274 54.6274Z"
				fill="#00FFA3"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M49.0193 22.0383C49.8075 22.914 49.7365 24.2629 48.8607 25.0511L26.023 45.6051L16.0584 35.6405C15.2253 34.8074 15.2253 33.4567 16.0584 32.6236C16.8916 31.7904 18.2423 31.7904 19.0754 32.6236L26.1776 39.7257L46.0065 21.8797C46.8822 21.0915 48.2311 21.1625 49.0193 22.0383Z"
				fill="#00FFA3"
			/>
		</svg>
	);
};

export default SelectedAvatarIcon;
